import OperateInspectionHome from './views/Home.vue'
import OperateInspectionDetail from './views/InspectionDetail.vue'

export default {
  routes: [
    {
      path: '/operate/inspection',
      component: OperateInspectionHome,
      name: 'OperateInspectionHome',
      meta: { requiresAuth: true },
      children: [
        {
          path: 'inspections/:id([0-9]+)',
          component: OperateInspectionDetail,
          name: 'OperateInspectionDetail',
          props: (route) => ({ id: Number(route.params.id) }),
        },
      ],
    },
  ],
}
